import {
  SET_LOCAL_CART_GOODS,
  SET_CART_CHECKED_GOODS_ID,
  REMOVE_CART_CHECKED_GOODS_ID,
  SET_CART_CHECKED_PRESENT,
  RESET_CART_STORE,
  SET_CART_NEW_RECEIVE_PRESENT,
  INIT_CART_STORE,
} from '@/vuex/mutations-types';
const CART_CHECKED_GOODS_IDS = 'CART_CHECKED_GOODS_IDS';
const CART_CHECKED_PRESENT = 'CART_CHECKED_PRESENT';
const LOCAL_CART_LIST = 'LOCAL_CART_LIST';

const state = {
  localCartList: [], // 未登录状态本地购物车列表
  cartCheckedGoodsIds: [],
  cartCheckedPresent: { NORMAL: '', GLOBAL: '' },
  cartNewReceivePresentId: '',
};

const mutations = {
  [INIT_CART_STORE](state, value) {
    const { localCartList = [], cartCheckedGoodsIds = [], cartCheckedPresent } = value;
    state.localCartList = localCartList;
    state.cartCheckedGoodsIds = cartCheckedGoodsIds;
    state.cartCheckedPresent = cartCheckedPresent || {
      NORMAL: '',
      GLOBAL: '',
    };
  },
  [SET_LOCAL_CART_GOODS](state, goods = {}) {
    let { commodityId, commodityIds, removeList = [], quantity, type } = goods;
    // 清空
    if (type === 'clear') {
      state.localCartList = [];
      uni.setStorageSync(LOCAL_CART_LIST, state.localCartList);
      return;
    }
    // 删除
    if (type === 'remove') {
      // 清空失效商品
      if (Array.isArray(commodityIds)) {
        state.localCartList = state.localCartList.filter(
          c => !commodityIds.includes(c.commodityId)
        );
      } else {
        // 删除指定商品
        state.localCartList = state.localCartList.filter(c => {
          const goods = removeList.find(
            l => l.commodityId === c.commodityId && l.skuId === c.skuId
          );
          if (goods) return false;
          return true;
        });
      }
      uni.setStorageSync(LOCAL_CART_LIST, state.localCartList);
      return;
    }
    if (!commodityId) return;

    const obj = state.localCartList.find(
      c => c.commodityId === commodityId && c.skuId === goods.skuId
    );
    quantity = Number(quantity);
    quantity = isNaN(quantity) ? 0 : quantity;

    if (obj) {
      // 更新数量
      if (type === 'update') {
        obj.quantity = goods.quantity;
      } else {
        // 增加
        obj.quantity += quantity;
      }
    } else {
      delete goods.type;
      state.localCartList.push(goods);
    }

    uni.setStorageSync(LOCAL_CART_LIST, state.localCartList);
  },
  [SET_CART_CHECKED_GOODS_ID](state, value) {
    if (!value) return;
    let cartCheckedGoodsIds = [...state.cartCheckedGoodsIds];
    if (typeof value === 'string') {
      cartCheckedGoodsIds.push(value);
    } else if (typeof value === 'object' && value instanceof Array) {
      cartCheckedGoodsIds = cartCheckedGoodsIds.concat(value);
    }
    cartCheckedGoodsIds = new Set(cartCheckedGoodsIds);
    cartCheckedGoodsIds = [...cartCheckedGoodsIds];
    state.cartCheckedGoodsIds = cartCheckedGoodsIds;
    uni.setStorageSync(CART_CHECKED_GOODS_IDS, cartCheckedGoodsIds);
  },
  [REMOVE_CART_CHECKED_GOODS_ID](state, value) {
    if (!value) return;
    let cartCheckedGoodsIds = [...state.cartCheckedGoodsIds];
    if (typeof value === 'string') {
      const index = cartCheckedGoodsIds.indexOf(value);
      if (index > -1) {
        cartCheckedGoodsIds.splice(index, 1);
      }
    } else if (typeof value === 'object' && value instanceof Array) {
      cartCheckedGoodsIds = cartCheckedGoodsIds.filter(item => value.indexOf(item) < 0);
    }
    cartCheckedGoodsIds = new Set(cartCheckedGoodsIds);
    cartCheckedGoodsIds = [...cartCheckedGoodsIds];
    state.cartCheckedGoodsIds = cartCheckedGoodsIds;
    uni.setStorageSync(CART_CHECKED_GOODS_IDS, cartCheckedGoodsIds);
  },
  [SET_CART_CHECKED_PRESENT](state, present) {
    const cartCheckedPresent = state.cartCheckedPresent;
    if (!present) {
      cartCheckedPresent.NORMAL = '';
      cartCheckedPresent.GLOBAL = '';
      uni.removeStorageSync('selectedPresent');
    } else if (present.type) {
      cartCheckedPresent[present.type] = present.id || '';
    }
    state.cartCheckedPresent = cartCheckedPresent;
    uni.setStorageSync(CART_CHECKED_PRESENT, cartCheckedPresent);
  },
  [RESET_CART_STORE](state) {
    state.cartCheckedGoodsIds = [];
    state.cartCheckedPresent = { NORMAL: '', GLOBAL: '' };
    uni.removeStorageSync(CART_CHECKED_GOODS_IDS);
    uni.removeStorageSync(CART_CHECKED_PRESENT);
    uni.removeStorageSync('selectedPresent');
  },
  [SET_CART_NEW_RECEIVE_PRESENT](state, id) {
    state.cartNewReceivePresentId = id;
  },
};
const actions = {
  initLocalCartStore({ commit }) {
    const localCartList = uni.getStorageSync(LOCAL_CART_LIST) || [];
    commit(INIT_CART_STORE, { localCartList });
  },
  initCartStore({ commit }) {
    const localCartList = uni.getStorageSync(LOCAL_CART_LIST) || [];
    const cartCheckedGoodsIds = uni.getStorageSync('CART_CHECKED_GOODS_IDS') || [];
    const cartCheckedPresent = uni.getStorageSync('CART_CHECKED_PRESENT');
    commit(INIT_CART_STORE, { localCartList, cartCheckedGoodsIds, cartCheckedPresent });
  },
};
export default {
  state,
  mutations,
  actions,
};
